export function getLocalStorage(key, defaultValue = null) {
  try {
    const value = localStorage.getItem(key);
    if (value === null) return defaultValue;

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  } catch (err) {
    console.error(`Error getting localStorage key “${key}”:`, err);
    return defaultValue;
  }
}

export function setLocalStorage(key, value) {
  try {
    const stringValue = typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(key, stringValue);
  } catch (err) {
    console.error(`Error setting localStorage key “${key}”:`, err);
  }
}

export function removeLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error(`Error removing localStorage key “${key}”:`, err);
  }
}